import { store } from '../../../redux/store'
import GardenService from "../GardenService";
import { dataChanged } from './gardenListSlice'
import ArrayUtils from "../../../utils/ArrayUtils";
import RequestQueue from "../../../utils/net/RequestQueue";

let isInitialized = false
let queue;

if (!isInitialized) {
    isInitialized = true
    queue = new RequestQueue()
    queue.subscribe({
        success: function (r) {
            const state = store.getState()

            if (state.gardenList.requestParams.offset > 0) {
                r.data.items = ArrayUtils.merge(state.gardenList.data.items, r.data.items, (i) => i.id)
            }

            store.dispatch(dataChanged(r.data))
        },
        error: function (r) {
            // TODO: rozwazyc powiadomienie uzytkownika o bledzie.
            console.error(r)
        },
        complete: function (r) {
            console.debug('Stream of garden list request has been completed.')
        } 
    })
}

const GardenListDataManager = {
    load: function() {
        const state = store.getState()
        queue.addRequest(GardenService.findGardens(state.gardenList.requestParams))
    }
}

export default GardenListDataManager